<app-common-offcanvas
  [width]="alertContainerWidth"
  [opened]="opened()"
  (close)="closeAlerts()"
>
  <div class="header px-4">
    <div class="w-100 d-flex align-items-center justify-content-between">
      <h2 class="h2-heading m-0 p-0">Alerts</h2>
    </div>
  </div>

  @if (!$selectedAlert()) {
    <div class="alert-details-container p-4">
      <div class="alert-details-body w-100 overflow-auto">
        <app-list-grid-client-side
          class="alert-details-grid"
          [rowData]="alertsList"
          [colDefs]="colDefs"
          [rowSelection]="alertsListRowSelection"
          [suppressRowClickSelection]="true"
          [paginationPageSize]="pageSizeService.getPageSize"
          [paginationPageSizeSelector]="false"
          [suppressCellFocus]="true"
          (gridReady)="onGridReady($event)"
          (sortChanged)="onSortChanged()"
        />
      </div>
    </div>
  } @else {
    <div class="info-container d-flex align-items-center border-bottom w-100">
      <button
        type="button"
        class="back-btn"
        (click)="backToAlerts()"
      >
        <i class="icon ic-arrow-left-20"></i>
      </button>

      <div class="flex-grow-1">
        <app-offcanvas-pagination-title
          [title]="$selectedAlert()?.type | alertsType"
          [currentIndex]="currentAlertIndex"
          [total]="totalRows"
          (moveToPrevious)="previousAlert()"
          (moveToNext)="nextAlert()"
        />
      </div>
    </div>

    <app-alert-details-content
      [alertSetter]="$selectedAlert()"
      [headerHeight]="'57px'"
      (updateAlert)="updateAlert($event)"
      (readStatusChange)="onAlertReaded($event)"
      (close)="backToAlerts()"
    />
  }
</app-common-offcanvas>
